import { useContext } from 'react'
import { GlobalSearchContext } from '../context/GlobalSearchContext'
import useGoBackState from 'shared/hooks/useGoBackState'
import { GlobalSearch, IconFile } from '@bbl-digital/snorre-v2'
import { getFileIcon } from 'shared/utils/file/fileIcon'

export const BoardDocumentSearchHits = () => {
  const { loading, boardDocumentHits } = useContext(GlobalSearchContext)
  const { push } = useGoBackState()

  const hasBoardDocumentHits = boardDocumentHits?.hits?.length

  const goToBoardDocument = (id: string) => {
    push(`/styrearbeid/arkiv/styrets/${id}`)
  }

  if (loading || !hasBoardDocumentHits) return null

  const mapHighlights = (highlights: string[]) => {
    return highlights?.map((highlight) => ({ key: 'text', value: [highlight] }))
  }

  const Hits = () => {
    return boardDocumentHits.hits?.map((item) => (
      <GlobalSearch.Item
        key={item.id}
        label={item.title}
        subtitle={item.filename}
        highlights={mapHighlights(item.highlightsText) || []}
        options={{
          renderHighlightsAsHtml: true,
        }}
        icon={
          <>
            {item.mimeType ? (
              <div className="flex items-center justify-center bg-surface-common-icon-highlight p-[4px] pr-[3px] min-h-[20px] min-w-[20px] rounded-card [&>svg]:!fill-surface-common-icon-color">
                {getFileIcon(item.mimeType, {
                  size: 'medium',
                })}
              </div>
            ) : (
              <IconFile colorVariant="primary" backgrounded />
            )}
          </>
        }
        onClick={() => goToBoardDocument(item.id)}
      />
    ))
  }

  return (
    <GlobalSearch.Group label="Styrets arkiv" title="Styrets arkiv">
      <Hits />
    </GlobalSearch.Group>
  )
}
